import styled, { css } from 'styled-components'
import { colors } from '../../styles'
import { FormControl } from '@material-ui/core'

export const StyledFormControl = styled(FormControl)`
  margin-bottom: 16px;
  ${(props: any) =>
    !!props.disabled &&
    css`
      svg {
        color: ${colors.grey40};
      }
    `}
` as React.ComponentType<any>

export const StyledPlaceholder = styled.span`
  color: ${colors.grey40};
` as React.ComponentType<any>
